import type { ApplyEffectContext } from "./effectContext.js";

export function startWorkerCycle(ctx: ApplyEffectContext, draw: number, actions: number): ApplyEffectContext {
  if (ctx.run.hand.length === 0) return ctx;
  return {
    ...ctx,
    run: {
      ...ctx.run,
      pendingChoice: {
        kind: "workerCycle",
        sourceInstanceId: ctx.sourceInstanceId,
        selected: [],
        draw,
        actions,
      },
    },
  };
}
